import { DropZone } from "../../../utilities/drag-drop";

export enum CollisionType {
  ChangePageBar = "ChangePageBar",
  Tile = "Tile",
}

export type CollisionResult = {
  type: CollisionType;
  hit: boolean;
  zone: DropZone;
};
